import { FieldLabel, type FieldLabelSize, Form, Input } from '@/components';
import { type AmountUnit, AmountUnitLabelModifier } from '@/utils';
import { NumericFormat, type NumericFormatProps } from 'react-number-format';

type Props = {
  title: string;
  value: NumericFormatProps['value'];
  unit: AmountUnit;
  size?: FieldLabelSize;
  fallbackText?: string;
};

export const CalculatedLabeledText = ({
  title,
  value,
  unit,
  size,
  fallbackText = '',
}: Props) => {
  return (
    <Form.Item label={<FieldLabel text={title} size={size} />}>
      <NumericFormat
        customInput={Input}
        disabled
        value={value ?? fallbackText}
        thousandSeparator=","
        addonAfter={AmountUnitLabelModifier[unit]}
      />
    </Form.Item>
  );
};
